.container {
  align-items: center;
  flex-flow: column-reverse;
  gap: var(--mirai-ui-space-XS);
  margin-bottom: var(--mirai-ui-space-S);
}

.container .divider {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: var(--mirai-ui-space-M);
  text-align: center;
  width: 100%;
}

.container .divider::before,
.container .divider::after {
  border-bottom: 1px solid var(--mirai-ui-content-border);
  content: '';
  flex: 1;
}
